import type { RouteObject } from 'react-router';

export const routes: RouteObject[] = [
  { path: 'communicate', lazy: async () => ({ Component: (await import('./CommunicatePage')).CommunicatePage }) },
];
